export const CONTACT_CREATE = "CONTACT_CREATE";
export const CONTACT_CREATE_FAILURE = "CONTACT_CREATE_FAILURE";
export const CONTACT_CREATE_SUCCESS = "CONTACT_CREATE_SUCCESS";
